import AddMaintenanceItemToSchadules from "../../../../Inputs/AddMaintenanceItemToSchadules/AddMaintenanceItemToSchadules";

export default function StatusMaintenanceItemsCarousel() {
  return (
    <div className="mt-5 companySection">
      <div className="mx-5">
        <h2 className="text-white mb-4">إضافة جدول</h2>
        <AddMaintenanceItemToSchadules />
      </div>
    </div>
  );
}
